import script from "./SettingsShiftContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./SettingsShiftContent.vue?vue&type=script&setup=true&lang=ts"

import "./SettingsShiftContent.vue?vue&type=style&index=0&id=6dfe66d4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6dfe66d4"]])

export default __exports__